import React, { FC } from 'react';
import { useTranslate } from 'react-admin';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { JsonInput } from './JsonInput';

interface QuickQuoteFormProps {
  keyName: string;
}

export const QuickQuoteForm: FC<QuickQuoteFormProps> = ({ keyName }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  return (
    <>
      <JsonInput
        label={t('countriesAndCurrencies')}
        source={`${keyName}.countriesAndCurrencies`}
        className={classes.schemaInput}
        validationError={t('jsonError')}
      />
    </>
  );
};
